import MainContent from "../components/MainContent";
import Layout from "../components/Layout";

const TracksPage = () => (
  <Layout>
    <MainContent contentType="tracks" />
  </Layout>
);

export default TracksPage;
